<template>
  <div class="py-20 bg-primary">
    <h1 class="text-5xl text-white">Impressum</h1>
  </div>
  <div class="py-20 bg-white">
    <div class="text-left lg:container lg:mx-auto">
      <h2 class="font-bold text-primary text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">Allgemein</h2>
      <p class="mb-5 text-primary">
        (Quelle: <a class="text-blue-400" href="https://www.e-recht24.de">eRecht24</a>)
      </p>
      <p class="mb-5 text-primary">
        <br />
        <b>Angaben gemäß § 5 TMG</b> <br /><br />
        Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
        coactum GmbH<br />
        Neuhäuser Straße 74<br />
        33102 Paderborn<br /><br />
        E-Mail: info(at)coactum(dot)de
      </p>
      <h3 class="text-base font-semibold text-primary">Haftung für Inhalte</h3>
      <p class="mb-5 text-primary">  
        Als Diensteanbieter sind wir gemäß § 7
        Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach § 8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen. <br />
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>
      <h3 class="text-base font-semibold text-primary">Haftung für Links</h3>
      <p class="mb-5 text-primary">
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
      <h3 class="text-base font-semibold text-primary">Urheberrecht</h3>
      <p class="mb-5 text-primary">
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        <br />
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p> 
      <p class="mb-5 text-primary">
        <em>zuletzt aktualisiert am 27. März 2025</em>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>
